import { useEffect, useRef } from 'react'
import useTelemetryStore from 'store/robotTelemetry'

import useRobot from './useRobot'

export default function useSetRobotTrajectory() {
  const { data: robot } = useRobot()
  const setInitialTrajectory = useTelemetryStore(s => s.setInitialTrajectory)
  const clearTrajectory = useTelemetryStore(s => s.clearTrajectory)
  const previousRobotSerialRef = useRef<number | null>(null)

  useEffect(() => {
    if (!robot) return
    if (previousRobotSerialRef.current !== robot.serialNumber) {
      previousRobotSerialRef.current = robot.serialNumber
      clearTrajectory()
    }
    if (robot.telemetryPositionData?.length) {
      setInitialTrajectory(robot.telemetryPositionData.map(({ position }) => [position.x, position.y]))
    }
  }, [robot, clearTrajectory, setInitialTrajectory])
}
